"use strict";
/* globals module */
/**
 * @module roleRoute
 * @description Baasic Role Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Role Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var contracts_1 = require("../../../core/contracts");
var RoleBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(RoleBatchRoute, _super);
    function RoleBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
        * Create route with route and query parameters.
        **/
        _this.createRoute = 'lookups/roles/batch';
        /**
        * Update route with route and query parameters.
        **/
        _this.updateRoute = 'lookups/roles/batch';
        /**
        * Delete route with route and query parameters.
        **/
        _this.removeRoute = 'lookups/roles/batch';
        return _this;
    }
    /**
     * Parses create batch roles route; this URI template does not expose any additional options.
     * @method
     * @example roleBatchRoute.create();
     **/
    RoleBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update batch roles route.
     * @method
     * @param data A role object used to update specified role resource.
     * @example roleBatchRoute.update(data);
     */
    RoleBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses delete batch roles route.
     * @method
     * @param data A role object used to delete specified role resource.
     * @example roleBatchRoute.delete(data);
     */
    RoleBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.removeRoute, {});
    };
    var _a;
    RoleBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], RoleBatchRoute);
    return RoleBatchRoute;
}(common_1.BaseRoute));
exports.RoleBatchRoute = RoleBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
*/ 
